import React from 'react'

const Footer: React.FC = () => {
  return (
    <footer className='bg-white bottom-0 left-0 h-16 p-4 w-full border-y-2 border-y-gray-200'>
      <div className='container m-auto text-center'>
        <p className='text-xs text-gray-500'>
          ご不明な点がございましたら、 面談時に担当者にご相談ください
        </p>
      </div>
    </footer>
  )
}

export default Footer
